import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

import history from '../../../utils/history';

function ModalMoreQuestions({
  isOpen,
  onClose,
  userSetting,
  setFlashSectionChoose,
}) {
  const handleOnClose = () => {
    onClose(false);
  };

  const textSetting =
    userSetting && userSetting.flashcardOnly === 'noFlashcard'
      ? 'No Flash Cards'
      : userSetting && userSetting.flashcardOnly === 'flashcardOnly'
        ? 'Flash Cards Only'
        : '';

  return (
    <Modal isOpen={isOpen} toggle={handleOnClose}>
      <div>
        <div className="modal-header">
          <h5 className="modal-title">Study More Questions</h5>
          <i className="icon-close" onClick={handleOnClose} />
        </div>
      </div>
      <div />
      <ModalBody className="modal-body">
        <div>
          <p className="modal-message">
            You have more questions available, but your settings are currently
            limited to <strong>{textSetting}</strong>.
          </p>
          <p className="modal-instruction">
            To unlock more questions from this chapter:
          </p>
          <ol className="modal-steps">
            <li>
              <div className="ml-2">
                Go to your <strong>Account Settings</strong>
              </div>
            </li>
            <li>
              <div className="ml-2">
                Go to Choose <strong>Flash Cards Question</strong>
              </div>
            </li>
            <li>
              <div className="ml-2">
                Choose <strong>Default</strong> to access all questions
              </div>
            </li>
          </ol>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="container-button">
          <Button color="danger" onClick={handleOnClose}>
            Close
          </Button>
          <Button
            color="primary"
            onClick={() => {
              setFlashSectionChoose({
                value: true,
                typeChoose: 'Flash',
              });
              history.push('account-settings');
            }}
          >
            Go to Account Settings
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default ModalMoreQuestions;
